export default __webpack_public_path__ + "eade7d57ff1a1446a01c79bc436df14f.svg";